var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("application.actions.import.verifyToContinue")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("i18n", {
            attrs: {
              path: "application.actions.import.enterCodeBelow",
              tag: "p",
            },
            scopedSlots: _vm._u([
              {
                key: "email",
                fn: function () {
                  return [
                    _c("span", { staticClass: "bold text-primary" }, [
                      _vm._v(_vm._s(_vm.verificationEmail)),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("material-input", {
                    attrs: {
                      placeholder: _vm.$t("global.actions.verificationCode"),
                      label: _vm.$t("global.actions.verificationCode"),
                    },
                    model: {
                      value: _vm.localCode,
                      callback: function ($$v) {
                        _vm.localCode = $$v
                      },
                      expression: "localCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }